import React from 'react';
import { useLocation } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Header.css';

function Header() {
  const { cartCount, toggleCart } = useCart();
  const location = useLocation();

  // Hide cart on admin page
  if (location.pathname === '/admin') return null;

  return (
    <div className="global-header">
      <button className="cart-button" aria-label="Shopping cart" onClick={toggleCart}>
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          stroke="currentColor" 
          strokeWidth="2" 
          strokeLinecap="round" 
          strokeLinejoin="round"
        >
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
        {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
      </button>
    </div>
  );
}

export default Header;
